// Packages
export const FETCH_PACKAGES_REQUEST = 'FETCH_PACKAGES_REQUEST';
export const FETCH_PACKAGES_SUCCESS = 'FETCH_PACKAGES_SUCCESS';
export const FETCH_PACKAGES_FAILED = 'FETCH_PACKAGES_FAILED';




// WEBPACK FOOTER //
// ./src/constants/actionTypes.js